<button
  class="text-white font-bold rounded-l-full rounded-r-full block w-full h-16 lg:h-12 lg:w-36"
>
  {{ "buttons.get_info" | translate }}
</button>
